import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiUserByIdDto, ApiUserService } from '../../../@backoffice/services/api-user.service';

/** Route `data` key for the resolved API user (GET /api/APIUser/:userId). */
export const API_USER_RESOLVE_KEY = 'apiUser' as const;

/**
 * Pre-fetches API user details before activating the edit route.
 * On failure or invalid `userId`, navigates back to the API Users list and cancels navigation.
 */
export const apiUserResolver: ResolveFn<ApiUserByIdDto> = (route) => {
  const apiUserService = inject(ApiUserService);
  const router = inject(Router);

  const idParam = route.paramMap.get('userId');
  const userId = Number(idParam);
  if (!idParam || Number.isNaN(userId) || userId <= 0) {
    router.navigate(['/admin-settings/api-users']);
    return throwError(() => new Error('Invalid API user id'));
  }

  return apiUserService.getApiUserById(userId).pipe(
    catchError(() => {
      router.navigate(['/admin-settings/api-users']);
      return throwError(() => new Error('Failed to load API user'));
    })
  );
};
